import React from "react";
import { Card } from "reactstrap";
import { Button, Tag } from "antd";

export class CarCard extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {this.props.carsList.map((car, idx) => (
          <Card
            key={idx}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              marginBottom: "14px",
            }}
          >
            <div
              style={{
                minWidth: "150px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
              }}
            >
              <h6 style={{ margin: 0 }}>{car.name}</h6>
              <Tag color="green">
                {car.id === 4 && "John Arley"}
                {car.id === 5 && "Ivan Arjona"}
                {car.id === 2 && "Sin referencia"}
              </Tag>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Button
                type="link"
                onClick={() =>
                  this.props.handleOpenMarker(this.props.visitLength + idx)
                }
              >
                Ver Furgoneta
              </Button>
            </div>
          </Card>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeVisits/components/CarCard.jsx